const STORAGE_PREFIX = 'admin-list:'

export type AdminListPersistedState<TFilter> = {
  page: number
  searchQuery: string
  activeFilter: TFilter
}

export type AdminListLegacyPersistedState = {
  page: number
  searchQuery: string
  filterObject: Record<string, unknown> | null
  selectedDate?: string
  selectedType?: {value: string; label?: string} | null
}

export function readAdminListState<TFilter>(
  storageKey: string
): AdminListPersistedState<TFilter> | null {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${storageKey}`)
    if (!raw) return null
    const parsed = JSON.parse(raw) as AdminListPersistedState<TFilter>
    if (!parsed || typeof parsed.page !== 'number') return null
    if (!parsed.activeFilter) return null
    return parsed
  } catch {
    return null
  }
}

export function writeAdminListState<TFilter>(
  storageKey: string,
  state: AdminListPersistedState<TFilter>
): void {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${storageKey}`, JSON.stringify(state))
  } catch {
    /* quota / private mode */
  }
}

export function readAdminListLegacyState(
  storageKey: string
): AdminListLegacyPersistedState | null {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${storageKey}`)
    if (!raw) return null
    const parsed = JSON.parse(raw) as AdminListLegacyPersistedState
    if (!parsed || typeof parsed.page !== 'number') return null
    return parsed
  } catch {
    return null
  }
}

export function writeAdminListLegacyState(
  storageKey: string,
  state: AdminListLegacyPersistedState
): void {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${storageKey}`, JSON.stringify(state))
  } catch {
    /* ignore */
  }
}
